import { red } from '@material-ui/core/colors';
import { palette } from './palette';
import { colors } from '@material-ui/core';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.familysmilecenters-container': {
    /* General Styles */
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: palette.primary.light,
    },
    '& .MuiSwitch-track': {
      border: `1px solid ${palette.primary.main}`,
    },
    '& .MuiSwitch-thumb': {
      background: palette.primary.main,
    },

    '& .normal-text': {
      fontWeight: 300,
    },
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        backgroundColor: palette.background.header,
        color: palette.text.highlight,
        marginTop: 88,

        '& h1,& h2,& h3,& h4,& p': {
          color: palette.text.highlight,
        },
      },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      '& .hero-background': {
        objectFit: 'cover',
        // background: palette.background.fill,
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
        '@media screen and (min-width: 1100px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: 64,
        fontFamily: 'Lexend, Inter Display, sans-serif',
        fontWeight: '500 !important',
        color: palette.background.header,
        maxWidth: 634,
        '&.MuiTypography-root': {
          fontWeight: '500 !important',
        },
        '&[class*="jss"]': {
          fontWeight: '500 !important',
        },
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
        color: palette.text.secondary,
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Inter Display',
          maxWidth: 550,
        },
      },
      '& .MuiButton-outlinedSecondary': {
        color: palette.text.primary,
        borderColor: palette.primary.main,
        backgroundColor: palette.secondary.main,
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      paddingBottom: '0px !important',
      backgroundColor: palette.background.light,
      '& .section-alternate__content': {
        padding: '48px 16px',
        '& .section-header__title': {
          color: `${palette.background.header} !important`,
          fontSize: 48,
          fontFamily: 'Lexend, Inter Display, sans-serif',
          '&.MuiTypography-root': {
            fontWeight: '500 !important',
          },
          '&[class*="jss"]': {
            fontWeight: '500 !important',
          },
        },

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '& .definition-service-tile': {
          '@media (min-width: 600px)': {
            padding: '10px 24px',
          },
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
        '@media (max-width: 850px)': {
          display: 'grid !important',
          gridTemplateColumns: '1fr !important',
        },
      },
      '& .definition-services-grid .MuiGrid-item': {
        '@media (max-width: 850px)': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
      },
      '& .MuiCardContent-root': {
        padding: 32,
        borderRadius: 10,
        border: `1px solid ${palette.background.border}`,
        '@media (max-width: 600px)': {
          padding: '24px 24px',
        },
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 16,
      },
      '& .definition-service-title': {
        marginLeft: 16,
        fontWeight: 600,
        letterSpacing: '-0.32px',
        fontSize: 24,
        color: palette.text.primary,
      },
      '& .definition-service-description': {
        marginBottom: 0,
        color: palette.text.secondary,
        fontSize: 16,
        fontWeight: 400,
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.light,
      },
      '& .section-header__title': {
        color: `${palette.background.header} !important`,
        fontSize: 48,
        fontFamily: 'Lexend, Inter Display, sans-serif',
        '&.MuiTypography-root': {
          fontWeight: '500 !important',
        },
        '&[class*="jss"]': {
          fontWeight: '500 !important',
        },
      },
      '& .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
        {
          color: `${palette.text.primary} !important`,
        },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .description-cta': {
          '& p': {
            color: `${palette.background.header} !important`,
          },
        },
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-outlinedSecondary': {
            color: palette.text.primary,
            borderColor: palette.primary.main,
          },

        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.link,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      
      '& .howitworks-title': {
        marginBottom: 40,
        fontSize: 48,
      },

      '& .howitworks-wrapper': {
        padding: 20,
        '& .section-header': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '& .section-header__title': {
            color: `${palette.background.header} !important`,
            fontFamily: 'Lexend, Inter Display, sans-serif',
            '&.MuiTypography-root': {
              fontWeight: '500 !important',
            },
            '&[class*="jss"]': {
              fontWeight: '500 !important',
            },
          },
        },
        '& .step-subtitle-wrapper': {
          paddingRight: 100,
        },
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },
      '& .step-title': {
        color: palette.text.primary,
        fontSize: 24,
        fontWeight: 600,
      },
      '& .step-content': {
        color: palette.text.secondary,
        fontSize: 16,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '100px',
        },
      },

      '@media (max-width: 600px)': {
        paddingTop: '0px !important',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .home-hero-button': {
      },
      '& .savingsDataContainer': {
        '& .footer-bar':{
          backgroundColor: palette.surface.light,
        },
        '& .view-more-button':{
          backgroundColor: palette.primary.main,
          color: palette.text.highlight,
        }
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
          fontFamily: 'Lexend, Inter Display, sans-serif',
          '&.MuiTypography-root': {
            fontWeight: '500 !important',
          },
          '&[class*="jss"]': {
            fontWeight: '500 !important',
          },
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        backgroundColor: palette.surface.grey,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.surface.header,
      },
      '& .section-header__title': {
        color: palette.background.header,
        fontSize: 32,
        fontFamily: 'Lexend, Inter Display, sans-serif',
        '&.MuiTypography-root': {
          fontWeight: '500 !important',
        },
        '&[class*="jss"]': {
          fontWeight: '500 !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        borderColor: palette.surface.learnMore,
        color: palette.text.highlight,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        color: palette.text.primary,
        fontSize: 32,
        fontWeight: '500 !important',
        fontFamily: 'Lexend, Inter Display, sans-serif',
        '&.MuiTypography-root': {
          fontWeight: '500 !important',
        },
        '&[class*="jss"]': {
          fontWeight: '500 !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .provider-contact-details': {
        fontSize: 16,
        color: palette.text.secondary,
      },
      '& .provider-contact-link': {
        fontSize: 20,
        fontWeight: 500,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      // maxWidth: '898px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.header,
        color: palette.background.header,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.background.header, // Common border color for all states
      
      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        color: palette.background.header, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
      },
      
      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        color: palette.background.header, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },
      
      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        color: 'transparent', // Transparent background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.header, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,
      
      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },
      
      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: palette.background.header,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },
  },
};
